module.exports = __webpack_public_path__ + "img/37.2c455101.jpg";